import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  height: calc(100% - 40px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  cursor: pointer;
  position: relative;
`;

export const WidgetChatWrapper = styled.div`
  display: flex;
  padding: 16px 20px;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.colors.green6};
  background: ${({ theme }) => theme.colors.green1};
`;

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
export const ButtonsWrapper = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
`;
export const TitleText = styled.div`
  overflow: hidden;
  color: ${({ theme }) => theme.colors.black9};
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.2px;
`;

export const MessageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  width: 100%;
  border-radius: 8px;
`;
export const SenderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  align-self: stretch;
`;

export const NameWrapper = styled.div`
  font-weight: 600;
`;

export const DateWrapper = styled.div`
  color: ${({ theme }) => theme.colors.black6};
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
`;

export const ContentWrapper = styled.div`
  & > p {
    margin: 0;
  }
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  max-height: 44px;
  overflow: hidden;
  margin-left: 48px;
  word-break: break-word;
`;
